import {
  CircularProgress,
  MenuItem,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import { VisitorEmailPolicy } from "helpers/constants";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { VISITOR_EMAIL_POLICIES_OPTIONS } from "./VisitorEmailPolicySelect.constants";
import { SelectStyle } from "./VisitorEmailPolicySelect.style";
import { VisitorEmailPolicySelectProps } from "./VisitorEmailPolicySelect.type";

export function VisitorEmailPolicySelect({
  value,
  disabled,
  isLoading,
  onChange,
}: VisitorEmailPolicySelectProps) {
  const { t } = useTranslation("emailing");

  const selectedOption = useMemo(
    () =>
      VISITOR_EMAIL_POLICIES_OPTIONS.find((option) => option.value === value),
    [value],
  );

  const handleVisitorEmailPolicyChange = (
    event: SelectChangeEvent<unknown>,
  ) => {
    onChange(event.target.value as VisitorEmailPolicy);
  };

  return (
    <Stack gap={3} alignItems={"center"} direction={{ md: "row" }}>
      <Typography color={"primary"}>
        {t("visitorEmailPolicy.description")}
      </Typography>
      <SelectStyle
        value={value}
        onChange={handleVisitorEmailPolicyChange}
        disabled={disabled}
        fullWidth
        renderValue={() =>
          isLoading ? (
            <Stack direction="row" alignItems="center" gap={1}>
              <CircularProgress size={16} />
              <Typography color="primary" variant="body2">
                {t("visitorEmailPolicy.loading")}
              </Typography>
            </Stack>
          ) : (
            <Typography>
              {selectedOption ? t(selectedOption.label) : ""}
            </Typography>
          )
        }
      >
        {VISITOR_EMAIL_POLICIES_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Stack>
              <Typography color={"primary"}>{t(option.label)}</Typography>
              {option.description && (
                <Typography variant="caption">
                  ({t(option.description)})
                </Typography>
              )}
            </Stack>
          </MenuItem>
        ))}
      </SelectStyle>
    </Stack>
  );
}
